"use client";

import type { ReactNode } from "react";
import * as React from "react";

export type LinkProps = React.ComponentProps<"a"> & {
  href: string;
  children?: ReactNode;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
};

type LinkContextValue = {
  Override?: React.ComponentType<LinkProps>;
};

export const LinkContext = React.createContext<LinkContextValue>({});

export function LinkProvider(props: {
  component: React.ComponentType<LinkProps>;
  children: React.ReactNode;
}): React.ReactNode {
  const contextValue = React.useMemo(
    () => ({ Override: props.component }),
    [props.component]
  );

  return (
    <LinkContext.Provider value={contextValue}>
      {props.children}
    </LinkContext.Provider>
  );
}
